<template>
  <div id="app">
    <div v-if="maintenanceMode">rmCloud is currently under maintenance.  Please check back soon!</div>
    <router-view v-else></router-view>
  </div>
</template>

<script>
  export default {
    name: 'app',
    data () {
      return {
        maintenanceMode: process.env.MAINTENANCE_MODE
      }
    }
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// App.vue?7cd4227c